<div class="sample-app content-border-bottom">

  <div id="header"></div>
  <router-outlet ></router-outlet>
</div>

<div id="footer"></div>
